const requests = {};

requests.listEvents = function (args) {
  const filter = (args.start !== null && args.end !== null) ? `
  <c:comp-filter name="VCALENDAR">
    <c:comp-filter name="VEVENT">
      <c:time-range start="${args.start}" end="${args.end}" />
    </c:comp-filter>
  </c:comp-filter>` : `<c:comp-filter name="VCALENDAR" />`;
  return `
<c:calendar-query xmlns:d="DAV:" xmlns:c="urn:ietf:params:xml:ns:caldav">
    <d:prop>
        <d:getetag />
        <c:calendar-data />
    </d:prop>
    <c:filter>
      ${filter}
    </c:filter>
</c:calendar-query>
  `.trim();
};

requests.searchEvents = function (args) {
  const filter = `<c:comp-filter name="VCALENDAR">
  <c:comp-filter name="VEVENT">
      ${args.start !== null && args.end !== null &&
        `<c:time-range start="${args.start}" end="${args.end}" />`}
      </c:comp-filter>
    </c:comp-filter>`;
  return `
<c:calendar-query xmlns:d="DAV:" xmlns:c="urn:ietf:params:xml:ns:caldav">
    <d:prop>
        <c:calendar-data />
    </d:prop>
    <c:filter>
      ${filter}
    </c:filter>
</c:calendar-query>
  `.trim();
};

requests.eventById = function (args) {
  return `
  <?xml version='1.0' encoding='utf-8'?>
  <C:calendar-multiget xmlns:C="urn:ietf:params:xml:ns:caldav" xmlns:CS="http://calendarserver.org/ns/" xmlns:D="DAV" xmlns:I="http://apple.com/ns/ical/">
    <ns0:prop xmlns:ns0="DAV:">
    <ns0:getetag/>
    <C:calendar-data/>
    </ns0:prop>
    <ns0:href xmlns:ns0="DAV:">${args.href}</ns0:href>
  </C:calendar-multiget>
  `.trim();
};

requests.createCalendar = function (args) {
  return `
   <?xml version="1.0" encoding="utf-8" ?>
   <C:mkcalendar xmlns:D="DAV:"
                 xmlns:C="urn:ietf:params:xml:ns:caldav"
                 xmlns:E="http://apple.com/ns/ical/">
     <D:set>
       <D:prop>
         <D:displayname>${args.name}</D:displayname>
         <E:calendar-color>${args.color}</E:calendar-color>
         <C:calendar-description xml:lang="en">${args.description}</C:calendar-description>
         <C:supported-calendar-component-set>
           <C:comp name="VEVENT"/>
         </C:supported-calendar-component-set>
         <C:calendar-timezone><![CDATA[${args.data}]]></C:calendar-timezone>
       </D:prop>
     </D:set>
   </C:mkcalendar>
  `.trim();
};

requests.updateCalendar = function (args) {
  return `
   <?xml version="1.0" encoding="utf-8" ?>
    <d:propertyupdate xmlns:d="DAV:"
    xmlns:c="urn:ietf:params:xml:ns:caldav"
    xmlns:e="http://apple.com/ns/ical/">
      <d:set>
        <d:prop>
          <d:displayname>${args.name}</d:displayname>
          <e:calendar-color>${args.color}</e:calendar-color>
          <c:calendar-description xml:lang="en">${args.description}</c:calendar-description>
        </d:prop>
      </d:set>
    </d:propertyupdate>
  `.trim();
};

requests.principal = function () {
  return `
<d:propfind xmlns:d="DAV:">
  <d:prop>
     <d:current-user-principal />
  </d:prop>
</d:propfind>
  `.trim();
};

requests.shareCalendar = function () {
  return `<x5:publish-calendar xmlns:x5="http://calendarserver.org/ns/"/>`.trim();
};

requests.test = function () {
  return `
    <?xml version="1.0" encoding="UTF-8"?>
      <x0:propfind xmlns:x0="DAV:">
        <x0:prop>
            <x0:displayname />
            <x0:owner />
            <x0:resourcetype />
            <x0:sync-token />
            <x0:current-user-privilege-set />
            <x4:invite xmlns:x4="http://owncloud.org/ns" />
            <x5:allowed-sharing-modes xmlns:x5="http://calendarserver.org/ns/" />
            <x5:publish-url xmlns:x5="http://calendarserver.org/ns/" />
            <x6:calendar-order xmlns:x6="http://apple.com/ns/ical/" />
            <x6:calendar-color xmlns:x6="http://apple.com/ns/ical/" />
            <x5:getctag xmlns:x5="http://calendarserver.org/ns/" />
            <x1:calendar-description xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:calendar-timezone xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:supported-calendar-component-set xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:supported-calendar-data xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:max-resource-size xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:min-date-time xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:max-date-time xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:max-instances xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:max-attendees-per-instance xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:supported-collation-set xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:calendar-free-busy-set xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:schedule-calendar-transp xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x1:schedule-default-calendar-URL xmlns:x1="urn:ietf:params:xml:ns:caldav" />
            <x4:calendar-enabled xmlns:x4="http://owncloud.org/ns" />
            <x3:owner-displayname xmlns:x3="http://nextcloud.com/ns" />
        </x0:prop>
      </x0:propfind>
  `.trim();
};

requests.invitedUsers = function () {
  return `
    <?xml version="1.0" encoding="UTF-8"?>
        <x0:propfind xmlns:x0="DAV:">
          <x0:prop>
              <x4:invite xmlns:x4="http://owncloud.org/ns" />
          </x0:prop>
        </x0:propfind>
  `.trim();
};

requests.publishCalendarLink = function () {
  return `
    <x5:publish-calendar xmlns:x5="http://calendarserver.org/ns/"/>
  `.trim();
};

requests.unpublishCalendarLink = function () {
  return `<x5:unpublish-calendar xmlns:x5="http://calendarserver.org/ns/"/>`.trim();
};

requests.calendarHome = function () {
  return `
<d:propfind xmlns:d="DAV:" xmlns:c="urn:ietf:params:xml:ns:caldav">
  <d:prop>
     <c:calendar-home-set />
  </d:prop>
</d:propfind>
  `.trim();
};

requests.calendarList = function () {

  return `
<d:propfind xmlns:d="DAV:" xmlns:cs="http://calendarserver.org/ns/" 
xmlns:c="urn:ietf:params:xml:ns:caldav"
xmlns:e="http://apple.com/ns/ical/">
  <d:prop>
     <d:resourcetype />
     <d:owner />
     <d:displayname />
     <d:current-user-privilege-set />
     <e:calendar-color />
     <c:calendar-description />
     <cs:getctag />
     <d:sync-token />
     <c:supported-calendar-component-set />
  </d:prop>
</d:propfind>
  `.trim();
};

requests.getChanges = function (args) {
  return `
<?xml version="1.0" encoding="utf-8" ?>
<d:sync-collection xmlns:d="DAV:">
  <d:sync-token>${args.syncToken}</d:sync-token>
  <d:sync-level>1</d:sync-level>
  <d:prop>
    <d:getetag/>
  </d:prop>
</d:sync-collection>
  `.trim();
};

requests.addressbooks = function () {
  return `
<d:propfind 
xmlns:d="DAV:" 
xmlns:cs="http://calendarserver.org/ns/"
xmlns:card="urn:ietf:params:xml:ns:carddav">
  <d:prop>
     <d:displayname />
     <cs:getctag />
  </d:prop>
</d:propfind>
  `.trim();
};

requests.contacts = function () {
  return `
  <card:addressbook-query xmlns:d="DAV:" xmlns:card="urn:ietf:params:xml:ns:carddav">
  <d:prop>
      <d:getetag />
      <card:address-data>
       <card:prop name="FN"/>
       <card:prop name="EMAIL"/>
       <card:prop name="TEL"/>
       <card:prop name="CATEGORIES"/>
      </card:address-data>
  </d:prop>
</card:addressbook-query>
  `.trim();
};

requests.filterContacts = function (args) {
  return `
  <card:addressbook-query xmlns:d="DAV:" xmlns:card="urn:ietf:params:xml:ns:carddav">
  <d:prop>
      <d:getetag />
      <card:address-data>
       <card:prop name="FN"/>
       <card:prop name="EMAIL"/>
       <card:prop name="TEL"/>
       <card:prop name="CATEGORIES"/>
      </card:address-data>
  </d:prop>
  <card:filter test="anyof">
    <card:prop-filter name="EMAIL">
      <card:text-match match-type="contains">${args}</card:text-match>
    </card:prop-filter>
    <card:prop-filter name="FN">
      <card:text-match match-type="contains">${args}</card:text-match>
    </card:prop-filter>
  </card:filter>
</card:addressbook-query>
  `.trim();
};

requests.shareCalendarView = function (args) {
  return `
    <x4:share xmlns:x4="http://owncloud.org/ns"><x4:set><x0:href xmlns:x0="DAV:">principal:principals/users/${args.contact}</x0:href></x4:set></x4:share>
  `;
};

requests.shareCalendarEdit = function (args) {
  return `
    <x4:share xmlns:x4="http://owncloud.org/ns"><x4:set><x0:href xmlns:x0="DAV:">principal:principals/users/${args.contact}</x0:href><x4:read-write/></x4:set></x4:share>
  `;
};

requests.shareCalendarDelete = function (args) {
  return `
    <x4:share xmlns:x4="http://owncloud.org/ns"><x4:remove><x0:href xmlns:x0="DAV:">principal:principals/users/${args.contact}</x0:href></x4:remove></x4:share>
  `;
};

requests.trashBinCalendars = function () {
  return `
  <x1:calendar-query xmlns:x1="urn:ietf:params:xml:ns:caldav"><x0:prop xmlns:x0="DAV:"><x0:getcontenttype/><x0:getetag/><x0:resourcetype/><x1:calendar-data/><x3:calendar-uri xmlns:x3="http://nextcloud.com/ns"/><x3:deleted-at xmlns:x3="http://nextcloud.com/ns"/></x0:prop><x1:filter><x1:comp-filter name="VCALENDAR"><x1:comp-filter name="VEVENT"/></x1:comp-filter></x1:filter></x1:calendar-query>
  `;
};

requests.createPersonalCalendar = () =>
  `
  <x0:mkcol xmlns:x0="DAV:">
  <x0:set>
      <x0:prop>
          <x0:resourcetype>
              <x0:collection/>
              <x1:calendar xmlns:x1="urn:ietf:params:xml:ns:caldav"/>
          </x0:resourcetype>
          <x0:displayname>Personal</x0:displayname>
          <x6:calendar-color xmlns:x6="http://apple.com/ns/ical/">#795AAB</x6:calendar-color>
          <x4:calendar-enabled xmlns:x4="http://owncloud.org/ns">1</x4:calendar-enabled>
          <x1:calendar-timezone xmlns:x1="urn:ietf:params:xml:ns:caldav">BEGIN:VCALENDAR
  PRODID:-//IDN nextcloud.com//Calendar app 4.6.0//EN
  CALSCALE:GREGORIAN
  VERSION:2.0
  BEGIN:VTIMEZONE
  TZID:Europe/Madrid
  BEGIN:DAYLIGHT
  TZOFFSETFROM:+0100
  TZOFFSETTO:+0200
  TZNAME:CEST
  DTSTART:19700329T020000
  RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=-1SU
  END:DAYLIGHT
  BEGIN:STANDARD
  TZOFFSETFROM:+0200
  TZOFFSETTO:+0100
  TZNAME:CET
  DTSTART:19701025T030000
  RRULE:FREQ=YEARLY;BYMONTH=10;BYDAY=-1SU
  END:STANDARD
  END:VTIMEZONE
  END:VCALENDAR</x1:calendar-timezone>
            <x1:supported-calendar-component-set xmlns:x1="urn:ietf:params:xml:ns:caldav">
                <x1:comp name="VEVENT"/>
            </x1:supported-calendar-component-set>
        </x0:prop>
    </x0:set>
  </x0:mkcol>
  `.trim();


export default requests;
